import React from 'react';
import { useTranslation } from 'react-i18next';

import { MapItem, TransportItem } from '../types';
import { formatDate, formatLocation } from '../utils';
import styles from '../styles.module.scss';

interface TransportItemCardProps {
  item: MapItem;
  isSelected: boolean;
  templateId?: string;
  searchRoute: string;
  itemIdParam: string;
  onClick: () => void;
}

export const TransportItemCard: React.FC<TransportItemCardProps> = ({
  item,
  isSelected,
  templateId,
  searchRoute,
  itemIdParam,
  onClick,
}) => {
  const { t } = useTranslation();
  const transport = item as TransportItem;
  const loadingAddr = transport.loading_address;
  const unloadingAddr = transport.unloading_address;
  const bodyTypes = transport.transport_bodytypes?.map(bt => bt.value || bt.title).filter(Boolean).join(', ')
    || transport.transport_bodytype?.value || transport.transport_bodytype?.title || '';
  const loadingTypes = transport.loading_types?.join(', ') || '';

  const handleOpenClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    window.open(`${searchRoute}?templateId=${templateId}&${itemIdParam}=${transport.id}`, '_blank');
  };

  return (
    <div
      className={`${styles.freightCard} ${isSelected ? styles.freightCardSelected : ''}`}
    >
      <div className={styles.freightCardHeader} onClick={onClick}>
        <div className={styles.freightCardRoute}>
          <span className={styles.freightCardFrom}>
            {formatLocation(loadingAddr)}
            {(transport.available_from || transport.available_to) && (
              <span className={styles.freightCardDates}>
                {transport.available_from && formatDate(transport.available_from)}
                {transport.available_from && transport.available_to && ' – '}
                {transport.available_to && formatDate(transport.available_to)}
              </span>
            )}
          </span>
          <span className={styles.freightCardArrow}>&rarr;</span>
          <span className={styles.freightCardTo}>
            {formatLocation(unloadingAddr)}
          </span>
        </div>

        {bodyTypes && (
          <div className={styles.freightCardTransport}>
            <span className={styles.freightCardLabel}>{t('transport.bodyType', 'Тип транспорта')}:</span> {bodyTypes}
          </div>
        )}

        {loadingTypes && (
          <div className={styles.freightCardTransport}>
            <span className={styles.freightCardLabel}>{t('transport.loadingType', 'Тип загрузки')}:</span> {loadingTypes}
          </div>
        )}

        <div className={styles.freightCardMeta}>
          {transport.carrying_capacity && <span><span className={styles.freightCardLabel}>{t('transport.carryingCapacity', 'Грузоподъемность')}:</span> {transport.carrying_capacity} {t('common.tons', 'т')}</span>}
          <span className={styles.freightCardPrice}>
            {transport.price && Number(transport.price) !== 0 ? `${transport.price} ${transport.currency || ''}` : t('common.priceOnRequest', 'Цена по запросу')}
          </span>
        </div>
      </div>
      <button
        className={styles.freightCardButton}
        onClick={handleOpenClick}
      >
        {t('common.open', 'Открыть')}
      </button>
    </div>
  );
};
